import React from "react";

import InputMask from "react-input-mask";

const NewInput = ({ label, mask, type = "text", placeholder, onChange, onKeyDown, value, custom, register, disabled, name }) => {

  return (
    <div className={`input-wrapper ${custom}`}>
      <label className="input-label">{label}</label>
      <InputMask {...register(name)} mask={mask} maskChar=" " name={name} className="input"  type={type} placeholder={placeholder} onChange={onChange} value={value} disabled={disabled} />
    </div>
  );
}

export default NewInput;